/*! @azure/msal-common v16.11.0 2026-06-30 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const CcsCredentialType = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN",
};

export { CcsCredentialType };
//# sourceMappingURL=CcsCredential.mjs.map
